/*
 * <section-schedule data-show-from="YYYY/MM/DD HH:MM AM" data-hide-after="YYYY/MM/DD HH:MM PM">
 * Mostra il contenuto solo dentro la finestra temporale (ora del browser), così la cache pagina
 * di Shopify non blocca l'accensione/spegnimento automatico. In editor è sempre visibile.
 * Usato da: countdown-timer (Promo Halloween 22-31/10/2026), barra Rewards del cart drawer.
 * Sempre visibile anche in editor, con ?schedule_preview=1 nell'URL e sui temi NON pubblicati (anteprime per cliente/team).
 */
if (!customElements.get('section-schedule')) {
  customElements.define(
    'section-schedule',
    class SectionSchedule extends HTMLElement {
      connectedCallback() {
        this.from = this.parseDate(this.dataset.showFrom);
        this.until = this.parseDate(this.dataset.hideAfter);
        this.evaluate();
      }

      disconnectedCallback() {
        clearTimeout(this.timeoutId);
      }

      parseDate(value) {
        if (!value) return null;
        const time = new Date(value).getTime();
        return Number.isNaN(time) ? null : time;
      }

      evaluate() {
        clearTimeout(this.timeoutId);
        const now = Date.now();
        const designMode = window.Shopify && window.Shopify.designMode;
        const preview = /[?&]schedule_preview=1/.test(window.location.search);
        const unpublishedTheme = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main');
        const notStarted = this.from !== null && now < this.from;
        const ended = this.until !== null && now > this.until;
        const visible = designMode || preview || unpublishedTheme || (!notStarted && !ended);

        this.toggleAttribute('hidden', !visible);
        this.classList.toggle('section-schedule--off', !visible);

        // Ricontrolla al prossimo confine (max ogni 10 minuti) per pagine lasciate aperte.
        let next = null;
        if (this.from !== null && now < this.from) next = this.from;
        else if (this.until !== null && now < this.until) next = this.until;
        if (next !== null) {
          const delay = Math.min(next - now + 500, 10 * 60 * 1000);
          this.timeoutId = setTimeout(() => this.evaluate(), delay);
        }
      }
    }
  );
}
